<script lang="ts" setup>
// @ts-expect-error no need for declaration file
import CollapseTransition from "@ivanv/vue-collapse-transition/src/CollapseTransition.vue";

const { id } = defineProps<{ id: string; title?: string | undefined; description: string }>();

// uses cookie for persisting the state of the hint alert
const hintAlertIsOpen = useCookie(`_ali_hint-alert-${id}`, {
  default: () => 1,
  maxAge: 60 * 60 * 24 * 30 * 6, // 6 months
});

const isOpen = computed({
  get: () => hintAlertIsOpen.value === 1,
  set: function (value: boolean) {
    hintAlertIsOpen.value = value ? 1 : 0;
  },
});

function toggleContent() {
  isOpen.value = !isOpen.value;
}
</script>

<template>
  <div class="relative w-full overflow-hidden rounded-lg bg-[#FDECC0] p-3 text-sm text-gray-900 ring-0">
    <div
      class="gap-md grid cursor-pointer grid-cols-[auto_1fr_auto] items-center"
      tabindex="0"
      role="button"
      :aria-expanded="isOpen"
      @click="toggleContent"
      @keydown.enter.prevent="toggleContent"
      @keydown.space.prevent="toggleContent"
    >
      <img src="/icons/hint.svg" alt="Hint" class="size-10 rounded-full text-base">
      <div class="font-semibold">
        {{ title }} 
      </div>
      <UIcon name="i-ph-caret-down" variant="link" color="neutral" size="xs" :class="[isOpen ? '' : 'rotate-180']" />
    </div>
    <CollapseTransition :duration="400">
      <div
        v-show="isOpen"
        class="[&_strong]:font-medium [&_a]:text-primary [&_a]:underline pt-4 [&_p]:leading-[22px] [&_ul]:list-inside [&_ul]:list-disc [&_ul]:mb-xs [&_ul_li]:leading-[24px]"
        v-html="description"
      />
    </CollapseTransition>
  </div>
</template>

<style scoped>

</style>
